import { Suspense, useContext, useRef } from 'react'
import { Environment} from '@react-three/drei'
import { ThreeContext } from './Context';
import Placeholder from "./Placeholder";
import { useQuery } from "react-query";
import Model from "./Model";
import Sun from "./Sun";

export default function Import({render}) {


  const {debug} = useContext(ThreeContext);
  const Light = useRef();
  //useHelper(Light, THREE.DirectionalLightHelper, 4,'red')

  const getPergolas = async () => {
    const res = await fetch("https://api.lucasarts.fr/kenzai/api.json");
    return res.json();
  };
 
  const {data, isLoading} = useQuery({
    queryKey :["Pergolas"],
    queryFn :  getPergolas
  })

  
  if(isLoading) return;


  return (
    < >      
      {/* <ambientLight /> */}
      <directionalLight ref={Light}
        intensity={1.0}
        castShadow 
        shadow-mapSize={[512, 512]}
        shadow-camera-far={500}
        shadow-camera-near={1}
        shadow-camera-top={20}
        shadow-camera-right={20}
        shadow-camera-left={-20}
        shadow-camera-bottom={-20}
        position={[20,20,-4]}
      />

      <Environment files="./Textures/hdri/venice_sunset_1k.hdr" /> 

      <Suspense fallback={<Placeholder position-y={3} scale={[9, 9, 9]} />}>
          <Model data={data}/>                     
          <Sun />  
      </Suspense> 

    </>
  )
}
